<template>
    <div class="indent">
        <div class="banner">
        </div>
        <div class="wrapper">
            <div class=WordSection1 style='layout-grid:15.6pt'>

<p class=MsoNormal><span lang=EN-US>1</span>、<span lang=EN-US>&nbsp; </span>运行软件，在弹出的<span
lang=EN-US>“</span>注册购买<span lang=EN-US>”</span>窗口中点击下方的<span lang=EN-US><img
width=85 height=36 id="图片 2" :src="img1"></span></p>

<p class=MsoNormal><span lang=EN-US>&nbsp;<img width=543 height=486 id="图片 1"
:src="img2"></span></p>

<p class=MsoNormal><span lang=EN-US>2</span>、<span lang=EN-US>&nbsp; </span>点击按钮<span
lang=EN-US><img width=40 height=34 id="图片 3"
:src="img3"></span><span lang=EN-US> </span>，搜索当前电脑上的<span
lang=EN-US>U</span>盘。</p>

<p class=MsoNormal><span lang=EN-US><img width=543 height=486 id="图片 7"
:src="img4"></span></p>

<p class=MsoNormal><span lang=EN-US>3</span>、<span lang=EN-US>&nbsp; </span>点击下拉按钮<span
lang=EN-US><img width=297 height=28 id="图片 6"
:src="img5"></span>，在弹出的下拉列表中选择用来授权的那个<span
lang=EN-US>U</span>盘（移动硬盘）</p>

<p class=MsoNormal><span lang=EN-US>4</span>、点击按钮<span lang=EN-US><img
width=130 height=45 id="图片 8" :src="img6"></span>，复制<span
lang=EN-US>U</span>盘信息码成功。</p>

<p class=MsoNormal><span lang=EN-US>3</span>、<span lang=EN-US>&nbsp; </span>把复制的<span
lang=EN-US>U</span>盘信息码发给我们，我们会为您在线开通授权。</p>

</div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            img1: require('./images/udiskImg/image001.png'),
            img2: require('./images/udiskImg/image002.png'),
            img3: require('./images/udiskImg/image003.png'),
            img4: require('./images/udiskImg/image004.png'),
            img5: require('./images/udiskImg/image005.png'),
            img6: require('./images/udiskImg/image006.png'),
        }
    }
}
</script>
<style lang="less">
    .indent{
        .banner{
            position: fixed;
            top: 0;
            left: 0;
            height: 60px;
            width: 100%;
            background: #198AF7;
        }
        .wrapper{
            padding-top: 60px;
            width: 1200px;
            margin: 0 auto;
        }
    }
</style>